import React from 'react';
import { Col, Row } from 'antd';

export default function DetailsUrlsFields({ data, client, flag }) {
    return (
        <div className="details-table">
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Web site
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.web_site_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            {`Terms & Conditions`}
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.terms_conditions_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Support page
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.support_page_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Blog page
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.blog_page_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Privacy Policy
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.privacy_policy_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Web App
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.web_app_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            CRM
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.crm_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Facebook
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.facebook_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            App Store
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.app_store_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Google Play
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.google_play_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Twitter
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.twitter_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            LinkedIn
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.linkedIn_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Contact us URL
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.contact_us_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Contact us email
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.contact_us_email || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Instagram
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.instagram_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Youtube
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.[flag]?.youtube_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
